import { FORM_DATA_KEYS_MAP } from '@/shared/constants/api.constants'
import type { SendFormDataFields, SendFormDataKeys } from '@/shared/types/api.types'

export const autoBindDecorator = <T extends object>(service: T) =>
  new Proxy(service, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver)
      return typeof value === 'function' ? value.bind(target) : value
    }
  })
  
export const serializeToFormData = (params: Partial<SendFormDataFields>) =>
  Object.entries(params).reduce((formData, [key, value]) => {
    const mappedKey = FORM_DATA_KEYS_MAP[key as SendFormDataKeys] ?? key
    const fdKey = `fields[${mappedKey}]`
    const fdValue = value + ''
    formData.set(fdKey, fdValue)
    return formData
  }, new FormData())

export const formDataGenerator = (data: object) =>
  Object.entries(data).reduce((d, [key, value]) => `${d ? d + '&' : ''}${key}=${value}`, '')